import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from './constant'

const routes: RouteRecordRaw[] = [
  {
    path: 'policy/:policyId',
    name: ROUTE_NAMES.POLICY_DETAILS,
    component: () =>
      import(
        '~/scopes/dashboard/services-hub/pages/PolicyDetails/PolicyDetails.vue'
      ),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: { required: true },
    },
  },
]
export default routes
